module.exports = __webpack_public_path__ + "static/img/6.5d000c3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/7/1/zh/6.png
// module id = u+6j
// module chunks = 0